import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CreateOrUpdateUserDto, SearchUserInputDto, SearchUserOutputDto } from "../models/user-management-model";
import { FranchiseAppGlobal } from "src/app/franchise-app-global";
import { AppConfigService } from "src/app/shared/providers/config.service";
import { DropDownList } from "../models/common/drop-down-list";
import { PagedResult } from "../models/common/pagination";
import { FileDto } from "src/app/shared/models/models";

@Injectable()
export class UserManagementService {
  private env;
  constructor(
    public http: HttpClient,
    private config: AppConfigService) {
    this.env = this.config.getConfig();
  }

  // User management
  GetUserTypesDDL(): Observable<DropDownList<number, string>[]> {
    let url = this.env.baseUrl + FranchiseAppGlobal.getUserTypesDDL;
    return this.http.get<DropDownList<number, string>[]>(url);
  }

  GetPermissionsDDL(): Observable<DropDownList<string, string>[]> {
    let url = this.env.baseUrl + FranchiseAppGlobal.getPermissionsDDL;
    return this.http.get<DropDownList<string, string>[]>(url);
  }

  GetAll(input: SearchUserInputDto): Observable<PagedResult<SearchUserOutputDto>> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.getAll;
    return this.http.post<PagedResult<SearchUserOutputDto>>(url, object);
  }
  GetByIdForUpdate(id: number): Observable<CreateOrUpdateUserDto> {
    let url = this.env.baseUrl + FranchiseAppGlobal.getByIdForUpdate + id;
    return this.http.get<CreateOrUpdateUserDto>(url);
  }
  Create(input: CreateOrUpdateUserDto): Observable<void> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.create;
    return this.http.post<void>(url, object);
  }
  Update(input: CreateOrUpdateUserDto): Observable<void> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.update;
    return this.http.put<void>(url, object);
  }
  Delete(id: number): Observable<void> {
    let url = this.env.baseUrl + FranchiseAppGlobal.delete + id;
    return this.http.delete<void>(url);
  }
  Activate(id: number): Observable<void> {
    let url = this.env.baseUrl + FranchiseAppGlobal.activate + id;
    return this.http.get<void>(url);
  }
  Dectivate(id: number): Observable<void> {
    let url = this.env.baseUrl + FranchiseAppGlobal.dectivate + id;
    return this.http.get<void>(url);
  }
  ExportExcel(input: SearchUserInputDto): Observable<FileDto> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.exportExcel;
    return this.http.post<FileDto>(url, object);
  }
  ExportPdf(input: SearchUserInputDto): Observable<FileDto> {
    var object = JSON.stringify(input);
    let url = this.env.baseUrl + FranchiseAppGlobal.exportPdf;
    return this.http.post<FileDto>(url, object);
  }
}
